import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AddressService } from 'services';
import { Country } from 'models';

@Injectable({
    providedIn: 'root'
})
export class CountriesResolver implements Resolve<Country[]> {
    constructor(private addressService: AddressService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Country[]> {
        return this.addressService.getCountries();
    }
}